export default "__VITE_ASSET__By$7i6$m__"